module.exports = __webpack_public_path__ + "static/video_poster_03.94ea5327.png";